import React from "react";

import { CATEGORY_NAMES } from "constants/dispensary";

import { Count } from "components/Count";

type Props = {
  menuItemsCount?: number;
  selectedCategory?: string | null;
};

const MenuItemCount: React.FC<Props> = ({
  menuItemsCount,
  selectedCategory,
}) => {
  if (typeof menuItemsCount !== "number") {
    return <div></div>;
  }

  return (
    <div>
      {menuItemsCount > 0 && (
        <div className="font-bold text-xs">
          <Count amount={menuItemsCount} noun="result" plural="results" />
          {selectedCategory &&
            ` for
        ${CATEGORY_NAMES[selectedCategory]?.toLowerCase()}`}
        </div>
      )}
    </div>
  );
};

export default MenuItemCount;
